import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Input, Table, DatePicker, Icon } from 'antd';

import { selectorIncidenciesEditadesAmbTipus } from '../../selectors/selector_estacio_formulari_dades';
import { columnesTaulaIncidencies } from './configuracioTaulaIncidencies';

import { 
    convertirTextAMomentUTC, 
    MASCARA_DDMMYYYY, 
    MASCARA_YYYYMMDD, 
    esDataFiPeriodeDeshabilitat, 
    esDataIniciPeriodeDeshabilitat 
} from '../../commons/gestioDates';
import { 
    estacioIntroduccioIncidenciesModificarIncidencia,
    estacioIntroduccioIncidenciesEliminarIncidencia 
} from '../../actions/estacio';

const { TextArea } = Input;

const utcDateRender = (current) => {
    return (
        <div className="ant-calendar-date" >
            {current.utc().date()}
        </div>
    );
};

const granuralitat = 'days';

class EstacioIntroduccioIncidenciesTaula extends Component {

    constructor(props) {

        super(props);

        this.renderIconeEliminarIncidencia = this.renderIconeEliminarIncidencia.bind(this);
        this.renderColumnaDataInici = this.renderColumnaDataInici.bind(this);
        this.renderColumnaDataFi = this.renderColumnaDataFi.bind(this);
        this.renderColumnaDescripcio = this.renderColumnaDescripcio.bind(this);
        this.onEditarDescripcio = this.onEditarDescripcio.bind(this);

        this.incidencies = this.afegirIdAlsRows(this.props.incidencies);

        this.columnes = this.crearColumnesPerTaula(columnesTaulaIncidencies());
    }

    componentWillReceiveProps(nextProps) {
        //Afegim els index als elements per poder utilitzarlos com id
        this.incidencies = this.afegirIdAlsRows(nextProps.incidencies);
    }

    afegirIdAlsRows(incidencies) {
        return incidencies.map((element, index) => {
            return {
                ...element,
                id: index
            };
        });
    }

    crearColumnesPerTaula(columnes) {
        const renders = {
            'dataInici': this.renderColumnaDataInici,
            'dataFi': this.renderColumnaDataFi,
            'descripcio': this.renderColumnaDescripcio
        };

        columnes.forEach((columna) => {
            const nomColumna = columna.key;

            if (typeof renders[nomColumna] !== 'undefined') {
                columna.render = renders[nomColumna];
            }
        });

        //Columna de eliminar
        columnes.push({
            title: '',
            className: 'estacio-introduccio-taula-columna-eliminar',
            render: this.renderIconeEliminarIncidencia
        });

        return columnes;
    }

    /**
     * Accio que es llença quan es modifica el datepicker dintre de la taula.
     * @param {*} idObservador
     * @param {*} atribut
     * @param {*} dataAsMoment
     */
    onEditarDataDeUnaIncidencia(idIncidencia, atribut, dataAsMoment) {
        //La data de alta es obligatoria, per tant no deixem possar nulls.
        if (atribut === 'dataInici' && !dataAsMoment) {
            return;
        }

        let data = {
            [atribut]: (dataAsMoment) ? dataAsMoment.startOf('day') : dataAsMoment
        };

        this.props.estacioIntroduccioIncidenciesModificarIncidencia(idIncidencia, data);
    }

    onEditarDescripcio(event, indexIncidencia) {
        const text = event.target.value;
        const data = {
            descripcio: text
        };
        this.props.estacioIntroduccioIncidenciesModificarIncidencia(indexIncidencia, data);
    }

    deshabilitarDataInici(dataCalendari, dataBaixa) {
        const dataActual = convertirTextAMomentUTC(this.props.dataActualText);
        return esDataIniciPeriodeDeshabilitat(dataCalendari, dataActual, dataBaixa, granuralitat);
    }

    deshabilitarDataFi(dataCalendari, dataAlta) {
        const dataActual = convertirTextAMomentUTC(this.props.dataActualText);
        return esDataFiPeriodeDeshabilitat(dataCalendari, dataActual, dataAlta, granuralitat);
    }

    renderDatepicker(options, dataAsText, id, columnaIndex) {

        const dataAsMoment = (dataAsText) ? convertirTextAMomentUTC(dataAsText, MASCARA_YYYYMMDD) : null;

        return <DatePicker
            placeholder='Seleccionar'
            dateRender={utcDateRender}
            value={dataAsMoment}
            format={MASCARA_DDMMYYYY}
            onChange={this.onEditarDataDeUnaIncidencia.bind(this, id, columnaIndex)}
            {...options}
        />;
    }

    renderColumnaDataInici(dataAsText, incidencia) {
        const dataIndexColumna = 'dataInici';

        const optionsPerDataInici = {
            allowClear: false,
            disabledDate: (data) => this.deshabilitarDataInici(data, incidencia.dataFi)
        };

        return this.renderDatepicker(optionsPerDataInici, dataAsText, incidencia.id, dataIndexColumna);
    }

    renderColumnaDataFi(dataAsText, incidencia) {
        const dataIndexColumna = 'dataFi';

        const optionsPerDataFi = {
            allowClear: true,
            disabledDate: (data) => this.deshabilitarDataFi(data, incidencia.dataInici)
        };

        return this.renderDatepicker(optionsPerDataFi, dataAsText, incidencia.id, dataIndexColumna);
    }

    renderColumnaDescripcio(text, incidencia) {
        const idIncidencia = incidencia.id;

        return <TextArea
            autosize={{ minRows: 1 }}
            placeholder='Descripció'
            value={text}
            onChange={(evt) => {
                this.onEditarDescripcio(evt, idIncidencia);
            }}
        />;
    }

    /**
     * Renderitza una icona que permet eliminar una incidencia.
     * @param {*} text
     * @param {*} record
     */
    renderIconeEliminarIncidencia(text, record) {
        return (
            <span>
                <Icon type="delete"
                    className="icona-eliminar-sense-margin icona-eliminar"
                    onClick={() => this.props.estacioIntroduccioIncidenciesEliminarIncidencia(record.id)}
                />
            </span>
        );
    }

    render() {

        return (
            <Table
                rowKey={(record, index) => index}
                dataSource={this.incidencies}
                columns={this.columnes}
                size='small'
                bordered
                pagination={{ pageSize: 4, hideOnSinglePage: true }} />
        );
    }
}

EstacioIntroduccioIncidenciesTaula.propTypes = {
    incidencies: PropTypes.arrayOf(
        PropTypes.shape({
            dataFi: PropTypes.string,
            dataInici: PropTypes.string.isRequired,
            descripcio: PropTypes.string,
            id: PropTypes.number,
            idTipusIncidencia: PropTypes.number.isRequired,
            tipus: PropTypes.string.isRequired
        })
    ),
    dataActualText: PropTypes.string.isRequired,
    estacioIntroduccioIncidenciesModificarIncidencia: PropTypes.func,
    estacioIntroduccioIncidenciesEliminarIncidencia: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        incidencies: selectorIncidenciesEditadesAmbTipus(state)
    };
};

const mapDispatchToProps = {
    estacioIntroduccioIncidenciesModificarIncidencia,
    estacioIntroduccioIncidenciesEliminarIncidencia
};

export default connect(mapStateToProps, mapDispatchToProps)(EstacioIntroduccioIncidenciesTaula);



// WEBPACK FOOTER //
// ./src/components/estacio/estacioIntroduccioIncidenciesTaula.js